// extracted by mini-css-extract-plugin
export default {"exp-farm-section":"VQ9AP5Ys","exp-section-title":"y1yskSzy","exp-farm-cards-row":"tshbDVC4","exp-farm-card-wrapper":"E69hRSPC"};